import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/css/superAdmin.css';
import {
  CSmartTable,
  CAvatar,
  CBadge,
  CButton,
  CCollapse,
  CCardBody,
} from '@coreui/react-pro';

import { DeleteCoupons, GetCoupons } from '../../../actions/product.js';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Loader from '../../../components/Utility/Loader.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logout from '../../../components/SuperAdmin/Logout.js';

class ManageCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      promoCodes: [],
      loader: false,
    };
  }

  componentDidMount() {
    // Example for loading users or promo codes
    this.props.GetCoupons().then((response) => {
      if (response.coupon.length) {
        this.setState({ promoCodes: response.coupon });
      } else {
        console.error('Failed to load data');
      }
    });
  }

  toggleDelete = (couponId) => {
    // Show confirmation modal
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this coupon?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            // Proceed with deletion if the user confirms
            console.log(couponId);
            this.props.DeleteCoupons(couponId).then((response) => {
              console.log(response.success);
              if (response.success) {
                this.setState((prevState) => ({
                  promoCodes: prevState.promoCodes.filter(
                    (coupon) => coupon.id !== couponId
                  ),
                }));
              } else {
                console.error('Failed to load data');
              }
            });
          },
        },
        {
          label: 'No',
          onClick: () => {
            console.log('Deletion cancelled');
          },
        },
      ],
    });
  };
  render() {
    console.log("this.state.promoCodes",this.state.promoCodes)
    const columns = [
      {
        key: 'id',
        label: 'S/N',
        _style: { width: '80px' },
        sorter: false,
        filter: false,
      },

      {
        key: 'couponName',
        label: 'Coupon Name',
        _style: { width: '180px' },
        sorter: true,
        filter: true,
      },
      {
        key: 'priceOrPercentage',
        label: 'Discount',
        _style: { width: '120px' },
        sorter: true,
        filter: true,
      },
      {
        key: 'validUse',
        label: 'Valid Until',
        _style: { width: '140px' },
        sorter: true,
        filter: true,
      },
      {
        key: 'createdAt',
        label: 'Created At',
        _style: { width: '180px' },
        sorter: true,
      },
      {
        key: 'actions',
        label: 'Actions',
        _style: { width: '120px' },
        sorter: false,
        filter: false,
      },
    ];

    return (
      <>
        <React.Fragment>
          <ToastContainer />
          {this.state.loader || this.props.loader ? <Loader /> : null}

          <section className="home-section">
            <nav className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
              <div className="sidebar-button">
                <i className="bx bx-menu sidebarBtn"></i>
                <span className="dashboard h5 mb-0">Promo Codes</span>
              </div>
              <Logout />
            </nav>

            <div className="container home-content">
              <div className="sales-boxes">
                <div className="recent-sales box">
                  <div className="row">
                    <div className="col-lg-9 col-md-9">
                      <div className="title ">Promo Codes</div>
                    </div>
                    <div className="col-lg-3 col-md-9">
                      <Link
                        to="/super-admin-promo-code-create"
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                        style={{
                          width: 200,
                          whiteSpace: 'nowrap',
                        }}
                        className="btn btn-primary col-lg-3"
                      >
                        Create Promo Code
                      </Link>
                    </div>
                  </div>
                  <div className="shadow-sm p-3">
                    {this.state.promoCodes.length > 0 ? (
                      <CSmartTable
                        items={this.state.promoCodes.map((item, index) => ({
                          ...item
                        }))}
                        columns={columns}
                        columnSorter
                        columnFilter
                        footer
                        itemsPerPageSelect
                        itemsPerPage={5}
                        pagination
                        scopedColumns={{
                          id: (item, index) => <td>{index + 1}</td>, // S/N column
                          couponName: (item) => <td>{item.couponName}</td>, // Coupon Name column
                          priceOrPercentage: (item) => (
                            <td>{item.priceOrPercentage}</td> // Discount column
                          ),
                          validUse: (item) => <td>{item.validUse}</td>, // Valid Until column
                          createdAt: (item) => <td>{item.createdAt}</td>, // Created At column
                          actions: (item) => (
                            <td>
                              <div className="d-flex">
                                <CButton
                                  color="danger"
                                  variant="outline"
                                  size="sm"
                                  shape="circle"
                                  className="ms-2"
                                  onClick={(event) =>
                                    this.toggleDelete(item.id)
                                  }
                                  title="Delete"
                                >
                                  <i className="fa fa-trash pt-1"></i>
                                </CButton>
                              </div>
                            </td>
                          ),
                        }}
                        tableFilter
                        tableProps={{
                          responsive: true,
                          hover: true,
                          striped: true,
                        }}
                        tableBodyProps={{
                          className: 'align-middle',
                        }}
                      />
                    ) : (
                      <p className="text-center text-muted">
                        No promo codes available yet.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    loader: state.Auth.loader,
    error: state.Auth.error,
  };
}

const mapDispatchToProps = {
  GetCoupons,
  DeleteCoupons,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ManageCustomer);
